webpackJsonp([80],{

/***/ 1477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(689);


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(94);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(451);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1477]);


// WEBPACK FOOTER //
// app/datetime.en-badf28ec51690e443855.js